// Note:
// * Maps types from `UIKit/UIView.h`

// Maps to: `UIView.AnimationCurve`
export type UIViewAnimationCurve = 
  | 'easeInOut'
  | 'easeIn'
  | 'easeOut'
  | 'linear';